export enum StorageKey {
    AUTH_TOKEN = 'AUTH_TOKEN',
    USER_NAME = 'USER_NAME',
    COMPANIES_INFO = 'COMPANY_INFO',
    REFRESH_TOKEN = 'REFRESH_TOKEN',
    SELECTED_CUSTOMER_IDENTITY = 'SELECTED_CUSTOMER_IDENTITY',
    SELECTED_CUSTOMER_TITLE = 'SELECTED_CUSTOMER_TITLE',
    USER_EMAIL = 'USER_EMAIL',
    AVAILABLE_SERVICES = 'AVAILABLE_SERVICES',
    RIGHT_INFOS = 'RIGHT_INFOS'
}
